import { render, staticRenderFns } from "./ImportFormal.vue?vue&type=template&id=63dd7bd8&scoped=true&"
import script from "./ImportFormal.vue?vue&type=script&lang=js&"
export * from "./ImportFormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dd7bd8",
  null
  
)

export default component.exports